import { useTranslation } from 'next-i18next'
import { Dialog } from 'ui/src/components/Dialog/Dialog'
import { LargeDialog } from 'ui/src/components/Dialog/LargeDialog'
import { Text } from 'ui/src/components/Text/Text'
import { yStack } from 'ui/src/patterns/stack'
import { sprinkles } from 'ui/src/theme/sprinkles.css'
import { InfoButton } from '../priceCalculator/PurchaseFormV2/OfferPresenterV2/InfoButton/InfoButton'
import { AddonComparisonDialogBody } from './AddonComparisonDialogBody'

export function AddonComparisonCard({
  baseTermsVersion,
  addonTermsVersion,
}: {
  baseTermsVersion: string
  addonTermsVersion: string
}) {
  const { t } = useTranslation('purchase-form')
  return (
    <LargeDialog.Root>
      <Dialog.Trigger asChild>
        <InfoButton className={sprinkles({ marginTop: 'md' })}>
          <div className={yStack()}>
            <Text as="div" size="xs">
              {t('COMPARE_ADDON_DIALOG_TRIGGER')}
            </Text>
            <Text as="span" color="textSecondary" size="xs" balance={true}>
              {t('COMPARE_ADDON_DIALOG_TRIGGER_DESCRIPTION')}
            </Text>
          </div>
        </InfoButton>
      </Dialog.Trigger>
      <LargeDialog.Content>
        <AddonComparisonDialogBody baseTermsVersion={baseTermsVersion} addonTermsVersion={addonTermsVersion} />
      </LargeDialog.Content>
    </LargeDialog.Root>
  )
}
